import React, { Component } from 'react';
import '../styles/Login.css';

class Login extends Component {
    closeLogin (){
        let loginModal = document.getElementById("loginModal")
        loginModal.style.display = "none";
    }
    showMessage(){
        let message = document.getElementById("messageLogin")
        message.innerText = "Credenciales incorrectas, verifique usuario y password"
    }
    render(){
        return(
            <div class="modal-login modal" id="loginModal">
                <a href="javascript:void(0)" class="closebtn" onClick={this.closeLogin}>&times;</a>
                <div class="login-form">
                    <p>Usuario</p>                    
                    <input placeholder="Ingrese su email" type="text" class="input-user"/>
                    <input placeholder="Contraseña" type="password" class="input-password"/>
                    <div>
                        <a href="javascript:void(0)" class="forget-password">Olvidé mi contraseña </a>
                    </div>
                    <div class="message-login-container">
                        <span class="message-login" id="messageLogin"></span>
                    </div>
                    <div class="login-btn-containter">
                        <button class="login-form-btn register-btn">REGISTRARSE</button>
                        <button class="login-form-btn login-btn" onClick={this.showMessage}>INGRESAR</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Login.js